import type { ContractStatus, ContractStatuses, ContractStatusesApi } from '../../models';

export const normalizeContractStatus = (status: string): ContractStatus => ({
  id: status,
  label: status,
});

export const normalizeContractStatuses = (response: ContractStatusesApi): ContractStatuses => {
  const list = [...response].sort((a, b) => a.localeCompare(b)).map(normalizeContractStatus);

  return {
    list,
    map: list.reduce(
      (acc, contractStatus) => {
        acc[String(contractStatus.id)] = contractStatus;
        return acc;
      },
      {} as ContractStatuses['map'],
    ),
  };
};
